import type { ReactNode } from "react";

type PageHeaderProps = {
  readonly actions?: ReactNode;
  readonly breadcrumb: readonly string[];
  readonly subtitle?: string;
  readonly title: ReactNode;
};

export function PageHeader({
  actions,
  breadcrumb,
  subtitle,
  title,
}: PageHeaderProps) {
  return (
    <header className="mb-[18px] flex items-start justify-between gap-4">
      <div>
        <div className="mb-1 text-xs text-ink-subtle">
          {breadcrumb.map((item, index) => (
            <span key={item}>
              {index > 0 ? <span className="mx-1.5">/</span> : null}
              {item}
            </span>
          ))}
        </div>
        <h1 className="text-[28px] font-extrabold leading-tight tracking-normal text-ink">
          {title}
        </h1>
        {subtitle ? (
          <p className="mt-1 max-w-3xl text-sm text-ink-muted">{subtitle}</p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
          {actions}
        </div>
      ) : null}
    </header>
  );
}
